<script setup>
import { computed, ref } from "vue";
import NotificationBar from "@/Components/NotificationBar.vue";
import { mdiCheckCircle, mdiContrastCircle, mdiAlertCircle } from "@mdi/js";

const props = defineProps({
    message: {
        type: String,
        required: true,
    },
    modelValue: {
        type: [String, Number, Boolean],
        default: null,
    },
    color: {
        type: String,
        default: "success",
    }
});

const value = computed({
  get: () => props.modelValue
});

const notificationSettingsModel = ref([]);
const notificationsOutline = computed(
  () => notificationSettingsModel.value.indexOf("outline") > -1
);

</script>
<template>
    <div v-if="value" class="sm:px-6 lg:px-8 px-4 sticky top-1 z-50">
        <div class="grid-cols-1 w-full flex justify-end">
            <NotificationBar :color="color" :icon="(color=='success' ? mdiCheckCircle : (color=='warning' ? mdiContrastCircle : mdiAlertCircle))"
                :outline="notificationsOutline"  class="col-span-1 p-1 lg:p-2 absolute">
                <!-- <b v-if="color=='success'">Ok - </b>
                <b v-else-if="color=='warning'">! </b>
                <b v-else-if="color=='danger'">Error - </b> -->
                <div class="mr-3" v-text="message"></div>
            </NotificationBar>
        </div>
    </div>
</template>
